import { useWatch } from 'react-hook-form';
import { useSelectPackageContext } from '../../PackageSelectionForm/selectPackageContext';
import { PricingProduct } from '../../../../../store/features/products/types';
import { PricingPackagesFormValues } from '../../../../../store/features/packages/types';
import { MuiStack } from '../../../../../../../modules/material';
import CheckboxField from '../../../../../shared/formElements/CheckboxField';
import SecondLevelListWrapper from '../shared/SecondLevelListWrapper';
import CardWrapper from '../shared/CardWrapper';
import ListHeading from './ListHeading';
import ProductOptions from '../ProductOptions';
import RelatedPrimaryProductCard from './RelatedPrimaryProductCard';

export interface RelatedPrimaryProductsProps {
  products: PricingProduct[];
  title: string;
}

export default function RelatedPrimaryProducts(
  props: RelatedPrimaryProductsProps,
) {
  const { products, title } = props;
  const fieldName = 'productsSelections.productMultipleIds';

  const { handleChangeSelections } = useSelectPackageContext();

  const productMultipleIds = useWatch<PricingPackagesFormValues>({
    name: fieldName,
  }) as PricingPackagesFormValues['productsSelections']['productMultipleIds'];

  return (
    <SecondLevelListWrapper
      heading={<ListHeading title={title} />}
      className="informa-payment-related-products"
    >
      <MuiStack spacing={2}>
        {products.map((product) => {
          const isProductOptions =
            product.productOptionsList.length > 0 &&
            productMultipleIds?.includes(product.id);

          return (
            <CardWrapper
              shiftedContent={
                isProductOptions && (
                  <MuiStack spacing={2.5}>
                    <ProductOptions options={product.productOptionsList} />
                  </MuiStack>
                )
              }
              paddingVariant="smallTopBottom"
              key={product.id}
              className="informa-payment-related-products__item"
            >
              <CheckboxField<PricingPackagesFormValues>
                name={fieldName}
                value={product.id}
                label={<RelatedPrimaryProductCard product={product} />}
                onChange={() => handleChangeSelections()}
                labelOffset="small"
                multiple
                sx={{ m: 0 }}
                data-testid="related-primary-checkbox-input"
              />
            </CardWrapper>
          );
        })}
      </MuiStack>
    </SecondLevelListWrapper>
  );
}
